export default __webpack_public_path__ + "static/media/menu_icon.5bc6d828.svg";